import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../assets/pairfon-logo-horizontal-dark.png";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          <img src={logo} alt="Pairfon logo" />
        </Link>

        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        <nav className={menuOpen ? "active" : ""}>
          <ul className="nav-buttons">
            <li>
              <Link to="/login" className="login">Login</Link>
            </li>
            <li>
              <Link to="/signup" className="signup">Sign Up</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
